/**
 * Peplink detail API client — lazy fetch of one box's tag-matched
 * Peplink + per-client roster. Hits `/api/boxes/{scu}/peplink`.
 */
import { apiFetch } from "./apiClient";

export interface PeplinkClientDetail {
  mac: string;
  name: string | null;
  ip: string | null;
  connection_type: string | null;
  is_hardwired: boolean;
  signal_strength: number | null;
  last_seen_utc: string | null;
}

export interface BoxPeplinkDetail {
  scu_name: string;
  smartbox_code: string | null;
  device_sn: string | null;
  device_name?: string | null;
  product_name?: string | null;
  fw_ver?: string | null;
  status?: string | null;
  client_count?: number;
  last_polled_utc?: string | null;
  last_online_utc?: string | null;
  offline_at_utc?: string | null;
  clients: PeplinkClientDetail[];
}

export async function fetchBoxPeplink(
  token: string,
  scu: string,
): Promise<BoxPeplinkDetail> {
  return apiFetch<BoxPeplinkDetail>(
    `/api/boxes/${encodeURIComponent(scu)}/peplink`,
    token,
  );
}
